import { render } from "./MobileAppLink.vue?vue&type=template&id=cce99c1a&scoped=true&ts=true"
import script from "./MobileAppLink.vue?vue&type=script&lang=ts"
export * from "./MobileAppLink.vue?vue&type=script&lang=ts"

import "./MobileAppLink.vue?vue&type=style&index=0&id=cce99c1a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cce99c1a"]])

export default __exports__